<template>
  <v-menu
    bottom
    left
    min-width="300px"
    max-width="320px"
    v-model="menu"
    :close-on-content-click="false"
    offset-y
    transition="slide-y-transition"
  >
    <v-btn dark icon slot="activator">
      <v-badge left color="accent" overlap v-model="notifications.length">
        <span class="caption" slot="badge">{{ notifications.length }}</span>
        <v-icon>notifications</v-icon>
      </v-badge>
    </v-btn>

    <v-card>
      <v-subheader v-if="notifications.length" class="subheading accent white--text">
        {{ $tc('newMessage', nbMessages, { count: nbMessages }) }}
      </v-subheader>
      <v-subheader v-else class="subheading accent white--text">
        {{ $tc('notif', 0) | cap }}
      </v-subheader>
      <v-btn
        v-if="notifications.length"
        color="accent"
        flat
        small
        @click="$store.commit('_Notifier/CLEAR_ALL')"
      >
        <v-icon left color="accent">clear_all</v-icon>
        {{ $t('clearAll') | cap }}
      </v-btn>

      <v-list three-line dense class="listeNotifications">
        <template>
          <div v-for="(notif, i) in notifications" :key="i">
            <v-list-tile
              
              v-if="notif.action.path && notif.type == 'message'"
              avatar
              @click="clickNotif(i)"
              :to="{path: notif.action.path}"
            >
              <v-list-tile-action>
                <v-badge overlap color="red" v-model="notif.count">
                  <span slot="badge" class="caption">{{ notif.count }}</span>
                  <v-icon class="accent--text" x-large>{{ notif.type }}</v-icon>
                </v-badge>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-sub-title v-if="notif.data.timestamp">
                  <i>{{ notif.data.timestamp | dateTime }}</i>
                </v-list-tile-sub-title>
                <v-list-tile-title>{{ notif.data.titre }}</v-list-tile-title>
                <v-list-tile-sub-title class="contentNotif">
                  <div>{{ notif.data.message }}</div>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            
            <v-list-tile
              v-else-if="notif.action.path && notif.target && notif.type == 'error'"
              :href="notif.action.path"
              target="notif.target"
            >
              <v-list-tile-action>
                  <v-icon class="red--text" x-large>{{ notif.type }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-sub-title v-if="notif.data.timestamp">
                  <i>{{ notif.data.timestamp | dateTime }}</i>
                </v-list-tile-sub-title>
                <v-list-tile-title>{{ notif.data.titre }}</v-list-tile-title>
                <v-list-tile-sub-title class="contentNotif">
                  <div>{{ notif.data.message }}</div>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              v-else-if="notif.action.path && !notif.target && notif.type == 'error'"
              :to="{path: notif.action.path}"
            >
              <v-list-tile-action>
                  <v-icon class="red--text" x-large>{{ notif.type }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-sub-title v-if="notif.data.timestamp">
                  <i>{{ notif.data.timestamp | dateTime }}</i>
                </v-list-tile-sub-title>
                <v-list-tile-title>{{ notif.data.titre }}</v-list-tile-title>
                <v-list-tile-sub-title class="contentNotif">
                  <div>notif.data.message</div>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              v-else
              avatar
              @click="clickNotif(i)"
            >
              <v-list-tile-action>
                <v-badge overlap color="red" v-model="notif.count">
                  <span slot="badge" class="caption">{{ notif.count }}</span>
                  <v-icon class="orange--text" x-large >{{ notif.type }}</v-icon>
                </v-badge>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-sub-title v-if="notif.data.timestamp">
                  <i>{{ notif.data.timestamp | dateTime }}</i>
                </v-list-tile-sub-title>
                <v-list-tile-title>{{ notif.data.titre }}</v-list-tile-title>
                <v-list-tile-sub-title class="contentNotif">
                  <div>notif.data.message</div>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          
            <v-divider  inset class="my-1" :key="i"></v-divider>
          </div>
        </template>
      </v-list>
    </v-card>

  </v-menu>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      menu: false
    }
  },

  computed: {
    notifications () {
      return this.$store.getters['_Notifier/notifsPersistantes']
    },
    nbMessages () {
      let count = 0
      this.notifications.forEach(notif => {
        if (notif.type === 'message' || notif.type === 'phone_in_talk' || notif.type === 'collections' || notif.type === 'error') {
          count += notif.count
        }
      })
      console.log('count notif', count)
      return count
    }
  },

  methods: {
    // Click sur une notification dans la liste
    // ouvre et efface la notification
    clickNotif (indexNotif) {
      this.$store.dispatch('_Notifier/OPEN_NOTIF', indexNotif)
    },
    onScroll (e) {
      this.menu = false
    }
  },

  filters: {
    dateTime (v) {
      return moment(v).format('llll')
    }
  }
}
</script>
<style>
.contentNotif {
  line-height: 1.2 !important;
}
.listeNotifications {
  overflow:   auto;
  min-height:   85px;
  max-height:   255px;
}
.positionCentralNotif {
      position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzNotifications.vue